/**
 * Caps Flatpickr so operational dates cannot be in the future.
 * Pass `allowFutureDates: true` in options to skip (rare).
 */
export function mergeOperationalDateCaps(flatpickrOptions = {}) {
  if (flatpickrOptions.allowFutureDates) {
    const { allowFutureDates: _a, ...rest } = flatpickrOptions;
    return rest;
  }
  // Ignore empty maxDate so we still apply the operational cap
  if (flatpickrOptions.maxDate != null && flatpickrOptions.maxDate !== '') {
    return { ...flatpickrOptions };
  }
  return {
    ...flatpickrOptions,
    maxDate: flatpickrOptions.enableTime ? new Date() : 'today',
  };
}
